<template>
  <div :class="`table-wrapper ${className}`">
    <table class="ver-table single">
      <tr
        v-for="row in rows"
        :key="row.title"
      >
        <th 
          v-text="row.title"
        />
        <td v-html="row.content" />
      </tr>
    </table>
  </div>
</template>

<script>
  export default {
    props: {
      rows: {
        type: Array,
        default: () => [
          { title: '保險公司', content: '富邦產險' },
          { title: '投保商品', content: '任意險E方案' },
          { title: '險種', content: '很長很長很長很長很長很長很長的內容，很長很長很長很長很長很長很長的內容，很長很長很長很長很長很長很長的內容' },
          { title: '投保期間', content: '1年期：2018/06/06 - 2019/06/06' },
          { title: '保費金額', content: '473元' }
        ]
      },
      className: {
        type: String,
        default: null
      }
    }
  };
</script>